import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import ObjectiveEditForm from '../../elements/objectives/form';
import Loading from './../../elements/loading';
import ObjectivesAdd from './../../elements/objectives/widget/objectives_add';

class ObjectiveEdit extends Component {
	render() {
		const { objectives} = this.props;
		return (
			objectives.isFetching ? <Loading/>:<ObjectiveEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.reset('objectives.edit');
	}
}

export default BaseLayout(ObjectiveEdit, {
	title:"Crear objetivo",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ObjectivesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/objectives/create.jsx